module.exports = __webpack_public_path__ + "media/images/application/template/arrow-down-aab8d3b1057bdb112486a782012d6cd0.png";